import Button from '../UI/Button'
import FloatingButton from '../UI/FloatingButton'
import { IHeadProps } from './types'

function Head(props: IHeadProps) {
  return (
    <FloatingButton innerProps={{id: props.id || (Math.random() + 1).toString(36).substring(7)}} text={props.buttonText || ''} onClick={props.buttonAction || undefined } disabled={props.disabled}/>
  )
}

export default Head